import type { SearchSchemaInput } from '@tanstack/react-router';
import { parseEnum } from '@/shared/lib/listSearch';

/**
 * Which tab of a contract is open. A search param rather than seven child
 * routes, for the same reason the player page uses one: they are seven views
 * of one record fetched in one request.
 */
export const CONTRACT_TABS = [
  'overview',
  'negotiation',
  'signature',
  'documents',
  'history',
  'clauses',
  'incentives',
] as const;

export type ContractTab = (typeof CONTRACT_TABS)[number];

export interface ContractDetailSearch {
  tab: ContractTab;
}

export function validateContractDetailSearch(
  search: Partial<Record<keyof ContractDetailSearch, unknown>> & SearchSchemaInput,
): ContractDetailSearch {
  return { tab: parseEnum(search.tab, CONTRACT_TABS) ?? 'overview' };
}
